define('config/config.preproduction', [

], function() {

    var config = {
        "environement": "preproduction",
        "assets_url": window.maz_baseurl || "",
        "ws_root_url": window.maz_rooturl || "",
        "ws_quickbuy_product": {
            "mobile": '{{ws_root_url}}/{{locale}}/get-quick-buy-product.json?productCode={{codeY}}',
            "desktop": '{{ws_root_url}}/beauty/{{locale}}/get-quick-buy-product.json?productCode={{codeY}}'
        },
        "ws_basket_product": {
            "mobile": '{{ws_root_url}}/{{locale}}/get-basket.json',
            "desktop": '{{ws_root_url}}/beauty/{{locale}}/get-basket.json'
        }
    };

    return config;
});
